import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SupportDashboardFiltersData } from '../models/support-dashboard-filters-data';
import { TicketsLoadData } from '../models/tickets-load-data';
import { ITicketsLookupFilters } from '../models/tickets-lookup-filters';
import { IFilterChipsData } from '../../reactive-filters/interfaces/filter-chips-data.interface';

@Injectable({
  providedIn: 'root',
})
export class SupportSharedDataService {
  dashboardOptions$ = new BehaviorSubject<{ name: string; value: string }[]>([]);
  showDashboardsSelector$ = new BehaviorSubject<boolean>(false);
  /** The data used for loading the tickets table */
  ticketsTableData: TicketsLoadData = {};

  dashboardFilters: SupportDashboardFiltersData | undefined;

  ticketsTableFilters: SupportDashboardFiltersData | undefined;

  ticketsLookupFilters: ITicketsLookupFilters = {};

  ticketsChipsData: IFilterChipsData[] = [];

  totalTicketsCount: number;
}
